export default __webpack_public_path__ + "static/2260-f330d67310559c58d78888316e8bae0b.gif";